import { render } from "./Confirmation.vue?vue&type=template&id=33fa48a8&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"

import "./Confirmation.vue?vue&type=style&index=0&id=33fa48a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fa48a8"]])

export default __exports__